module.exports = __webpack_public_path__ + "public/img/rubbish2.d520afcc.png";